@if (loading()) {
  <joii-loader
    class="avatar-loader"
    [size]="loaderSize()"
    [duration]="loadingAnimationDuration()"
    [ariaLabel]="'Avatar loading'"
  >
    <ng-container [ngTemplateOutlet]="avatarTemplate"></ng-container>
  </joii-loader>
} @else {
  <ng-container [ngTemplateOutlet]="avatarTemplate"></ng-container>
}

<ng-template #avatarTemplate>
  <div class="avatar">
    <img [src]="imageUrl()" alt="avatar" />
  </div>
</ng-template>
